import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

const ACCESS_KEY = 'pillot_access';
const REFRESH_KEY = 'pillot_refresh';

export const tokenStore = {
  get access() {
    return localStorage.getItem(ACCESS_KEY);
  },
  get refresh() {
    return localStorage.getItem(REFRESH_KEY);
  },
  set(access, refresh) {
    if (access) localStorage.setItem(ACCESS_KEY, access);
    if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
  },
  clear() {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
};

export const api = axios.create({ baseURL: API_URL, timeout: 120000 });

api.interceptors.request.use((config) => {
  const token = tokenStore.access;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original?._retry && tokenStore.refresh && !original.url.includes('/auth/')) {
      original._retry = true;
      try {
        refreshing = refreshing || axios.post(`${API_URL}/auth/refresh`, { refresh_token: tokenStore.refresh });
        const { data } = await refreshing;
        refreshing = null;
        tokenStore.set(data.access_token, data.refresh_token);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        refreshing = null;
        tokenStore.clear();
        window.dispatchEvent(new Event('pillot:logout'));
      }
    }
    return Promise.reject(error);
  },
);

export const errMsg = (error, fallback = 'Terjadi kesalahan') => {
  const d = error?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(', ');
  return error?.message || fallback;
};

export const fmtIDR = (n) => 'Rp ' + Number(n || 0).toLocaleString('id-ID');

/** Poll a long-running AI job until done. Resolves with result, rejects with error message. */
export const pollAiJob = async (siteId, jobId, { interval = 3000, timeout = 600000, onTick } = {}) => {
  const start = Date.now();
  while (Date.now() - start < timeout) {
    await new Promise((r) => setTimeout(r, interval));
    const { data } = await api.get(`/sites/${siteId}/ai/jobs/${jobId}`);
    onTick?.(data);
    if (data.status === 'done') return data.result;
    if (data.status === 'error') throw new Error(data.error || 'AI job failed');
  }
  throw new Error('AI job timeout');
};
export const fmtDate = (iso, lang = 'id') =>
  iso ? new Date(iso).toLocaleDateString(lang === 'id' ? 'id-ID' : 'en-US', { day: 'numeric', month: 'short', year: 'numeric' }) : '-';
